import { useGetConversionInboundCallRecordingUrlQuery } from 'app/apis/queryApi';
import { RootState } from 'app/store';
import AudioExternal, {
  AudioSourceTypes
} from 'common/components/audio/audio-external';
import { useState } from 'react';
import { useSelector } from 'react-redux';

interface CallRecordingDownloadProps {
  eventId: string;
}

const CallRecording = ({ eventId }: CallRecordingDownloadProps) => {
  const { siteId } = useSelector((state: RootState) => state.selectedSite);

  const [hasInitialisedRecording, setHasInitialisedRecording] = useState(false);

  const { data, isLoading } = useGetConversionInboundCallRecordingUrlQuery(
    {
      siteId,
      eventId
    },
    { skip: !hasInitialisedRecording }
  );

  return (
    <>
      <div>
        <AudioExternal
          identifier={eventId}
          audioSource={data?.url}
          audioSourceType={AudioSourceTypes.AudioMpeg}
          isInitialising={isLoading}
          onInitialise={() => setHasInitialisedRecording(true)}
        />
      </div>
    </>
  );
};

export default CallRecording;
